// extracted by mini-css-extract-plugin
export var fileUpload = "_dh-1";
export var modalButton = "_dh-0";